import $ from 'jquery';
import {scrollTo} from './scroll-to';

const Search = (el) => {
    const $el = $(el);
    const paramName = $el.data('param');
    const query = window.location.search.substring(1);
    const params = new URLSearchParams(query);
    const search = params.get(paramName) || params.get('s');
    if(search !== '' && search !== null) {
        scrollTo('#search-result', 20);
    }
};

export const SearchLink = (el) => {
    // toggle is the element with state update
    const toggle = document.getElementById(el.dataset.toggle);
    // control is the element that the toggle controls
    const control = document.getElementById(el.getAttribute('aria-controls'));
    const $control = $(control);
    el.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = el.classList.contains('js-state-search--active');
        if(isOpen) {
            $control.hide();
            toggle.classList.remove('js-state-search--open');
            el.classList.remove('js-state-search--active');
            el.setAttribute('aria-expanded', 'false');
            control.setAttribute('aria-hidden', 'true');
        } else {
            $control.show();
            toggle.classList.add('js-state-search--open');
            el.classList.add('js-state-search--active');
            el.setAttribute('aria-expanded', 'true');
            control.setAttribute('aria-hidden', 'false');

            // Open mobile menu
            if(!document.body.classList.contains('js-state-menu-open')) {
                document.querySelector('.js-toggle-menu').click();
            }

            control.querySelector('input[type="search"]').focus();
        }
    });

    control.querySelector('.js-search-close').addEventListener('click', () => {
        $control.hide();
        toggle.classList.remove('js-state-search--open');
        el.classList.remove('js-state-search--active');
        el.setAttribute('aria-expanded', 'false');
        control.setAttribute('aria-hidden', 'true');
    });
};

export default Search;
